// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* dev/50 — the docs/06 two-lane suggestions surface. Shares the review-card
   shell language; state is labeled, never color-only. */

.TEh6pZWjeyiRjNQFDaws {
  margin-top: 8px;
  border: 1px solid var(--curio-border);
  border-radius: 10px;
  background: var(--curio-surface-muted);
  padding: 10px 12px;
}

.lxNwowoVtOHtCWNB57Uf {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  font-weight: 600;
}
/* The default colour sits in :where() so it has no specificity: the chat panel's
   category tint class on the same element wins regardless of which stylesheet the
   bundler emits first (the dev/142 panel decomposition changed that order and the
   review/result cards lost their tint). */
:where(.lxNwowoVtOHtCWNB57Uf) {
  color: var(--curio-text-primary);
}

.bIMdKUKUdIgsrGv6MW4c {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
}

.JHdQP7XhXjhsxQSQVZ9A {
  margin-left: auto;
  font-size: 0.68rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--curio-text-meta);
}

.I5G_2bsHmbxxPbktqcUW {
  margin-top: 10px;
}

.BnBwgTvs6qG_5Fo0MP7R {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--curio-text-secondary);
  margin-bottom: 4px;
}

.INdRHs2pXwg4U6ocjwmD {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ouyAiTrRz_qoVZ3hP50Z {
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  padding: 8px 10px;
}

.F_1x3r5g_Pbj9oC3E1y4 {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
}

.F_1x3r5g_Pbj9oC3E1y4 input {
  margin-top: 3px;
}

.eKzeRSzyK6tPw49Keckv {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

/* Lined up under the row's text, past the checkbox. */
.ysb96DlvB8ubQ6Tq4FIf {
  display: flex;
  gap: 12px;
  margin: 6px 0 0 23px;
}

.VwqWuovNunvrQWufNd68 {
  border: 0;
  background: none;
  padding: 0;
  font: inherit;
  font-size: 0.74rem;
  font-weight: 600;
  color: var(--curio-text-primary);
  text-decoration: none;
  cursor: pointer;
}

.VwqWuovNunvrQWufNd68:hover {
  text-decoration: underline;
}

.yaH5mRuvkrFazwrON_TP {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.bcOJ3zxEg3AHxkHnkqnM {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--curio-text-primary);
}

.gixVx6KRSxX7ldsU5vo9 {
  font-size: 0.66rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--curio-text-secondary);
  border: 1px solid var(--curio-border-strong);
  border-radius: 999px;
  padding: 1px 8px;
}

.g4ho9r61LgieTEH17IIg,
.KxeZnVqKLe3gIlqhsG2h {
  font-size: 0.66rem;
  border-radius: 999px;
  padding: 1px 8px;
}

.g4ho9r61LgieTEH17IIg {
  color: var(--curio-success-text);
  border: 1px solid var(--curio-success-bg);
  background: var(--curio-success-bg);
}

.KxeZnVqKLe3gIlqhsG2h {
  color: var(--curio-text-secondary);
  border: 1px solid var(--curio-border);
  background: var(--curio-surface-muted);
}

.SdJCuvfFrfxadinoSFhg,
.A2bgDzSziMVzeNNw1QAi,
.WcIrRiTOrKOCSgO4pXmk,
.xKYoS8Yly6AVy0GolMoq {
  font-size: 0.74rem;
  color: var(--curio-text-secondary);
  word-break: break-word;
}

.A2bgDzSziMVzeNNw1QAi {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  color: var(--curio-text-secondary);
}

.xKYoS8Yly6AVy0GolMoq {
  color: var(--curio-warning-text);
}

/* dev/126: the node-attached Dataset Finder's confirm control. Same shape as
   dev/116's remedy button, so a card action reads like every other one. */
.tHzFFqSiJHfYIm7d9vEN {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 6px 10px 10px;
}

.VeXnuFg7DATkZhhWTKHA {
  font-size: 0.76rem;
  font-weight: 600;
  border-radius: 8px;
  padding: 4px 12px;
  cursor: pointer;
  border: 1px solid var(--curio-border-strong);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
}

.VeXnuFg7DATkZhhWTKHA:hover:not(:disabled) {
  border-color: var(--curio-text-secondary);
}

.VeXnuFg7DATkZhhWTKHA:disabled {
  cursor: default;
  opacity: 0.55;
}

.vgG7AYfJ6XiIuFAYhtm5,
.EIhd1qWkWiqsI2zSbyUv {
  font-size: 0.74rem;
  color: var(--curio-text-secondary);
}

.EIhd1qWkWiqsI2zSbyUv {
  color: var(--curio-danger-text, var(--curio-warning-text));
}

/* dev/132: a row the runtime could not fetch — the portal's own steps, and the
   shared catalog import right where they end. */
.cb6vmf_xMXQXg11Zwofr {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.74rem;
  color: var(--curio-text-secondary);
}

.Xiu89pA5PpRnNYAhvBHG {
  font-weight: 600;
  color: var(--curio-text-primary);
}

.BiNUBYJCBTiBHsYvNxxA {
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  word-break: break-word;
}

.TCmhD3ocs9b5Fw4Zx9IM {
  display: inline-flex;
  align-items: center;
  margin-top: 2px;
}

._1MuoJb22vH3gzmSk9oI {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
}

.SySO8r786VFHCXbbqEMq {
  font-size: 0.76rem;
  font-weight: 600;
  border-radius: 8px;
  padding: 4px 12px;
  cursor: pointer;
  border: 1px solid var(--curio-border-strong);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
}

.TCmhD3ocs9b5Fw4Zx9IM:hover .SySO8r786VFHCXbbqEMq {
  border-color: var(--curio-text-secondary);
}

.SySO8r786VFHCXbbqEMq[aria-disabled="true"] {
  cursor: default;
  opacity: 0.55;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/content/AgentDatasetCandidatesCard.module.css"],"names":[],"mappings":"AAAA;wDACwD;;AAExD;EACE,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;0CAG0C;AAC1C;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,4CAA4C;EAC5C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;;;EAIE,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;EAC3D,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;0EAC0E;AAC1E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;gDACgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,aAAa;AACf","sourcesContent":["/* dev/50 — the docs/06 two-lane suggestions surface. Shares the review-card\n   shell language; state is labeled, never color-only. */\n\n.card {\n  margin-top: 8px;\n  border: 1px solid var(--curio-border);\n  border-radius: 10px;\n  background: var(--curio-surface-muted);\n  padding: 10px 12px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n/* The default colour sits in :where() so it has no specificity: the chat panel's\n   category tint class on the same element wins regardless of which stylesheet the\n   bundler emits first (the dev/142 panel decomposition changed that order and the\n   review/result cards lost their tint). */\n:where(.header) {\n  color: var(--curio-text-primary);\n}\n\n.accentDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.kind {\n  margin-left: auto;\n  font-size: 0.68rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--curio-text-meta);\n}\n\n.lane {\n  margin-top: 10px;\n}\n\n.laneLabel {\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--curio-text-secondary);\n  margin-bottom: 4px;\n}\n\n.rows {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.row {\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  padding: 8px 10px;\n}\n\n.rowLabel {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.rowLabel input {\n  margin-top: 3px;\n}\n\n.rowBody {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n/* Lined up under the row's text, past the checkbox. */\n.rowActions {\n  display: flex;\n  gap: 12px;\n  margin: 6px 0 0 23px;\n}\n\n.rowLink {\n  border: 0;\n  background: none;\n  padding: 0;\n  font: inherit;\n  font-size: 0.74rem;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.rowLink:hover {\n  text-decoration: underline;\n}\n\n.rowHead {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.name {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.badge {\n  font-size: 0.66rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--curio-text-secondary);\n  border: 1px solid var(--curio-border-strong);\n  border-radius: 999px;\n  padding: 1px 8px;\n}\n\n.installedChip,\n.notInstalledChip {\n  font-size: 0.66rem;\n  border-radius: 999px;\n  padding: 1px 8px;\n}\n\n.installedChip {\n  color: var(--curio-success-text);\n  border: 1px solid var(--curio-success-bg);\n  background: var(--curio-success-bg);\n}\n\n.notInstalledChip {\n  color: var(--curio-text-secondary);\n  border: 1px solid var(--curio-border);\n  background: var(--curio-surface-muted);\n}\n\n.meta,\n.url,\n.fit,\n.requirement {\n  font-size: 0.74rem;\n  color: var(--curio-text-secondary);\n  word-break: break-word;\n}\n\n.url {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  color: var(--curio-text-secondary);\n}\n\n.requirement {\n  color: var(--curio-warning-text);\n}\n\n/* dev/126: the node-attached Dataset Finder's confirm control. Same shape as\n   dev/116's remedy button, so a card action reads like every other one. */\n.confirmRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px 10px;\n}\n\n.confirm {\n  font-size: 0.76rem;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 4px 12px;\n  cursor: pointer;\n  border: 1px solid var(--curio-border-strong);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n}\n\n.confirm:hover:not(:disabled) {\n  border-color: var(--curio-text-secondary);\n}\n\n.confirm:disabled {\n  cursor: default;\n  opacity: 0.55;\n}\n\n.recorded,\n.recordError {\n  font-size: 0.74rem;\n  color: var(--curio-text-secondary);\n}\n\n.recordError {\n  color: var(--curio-danger-text, var(--curio-warning-text));\n}\n\n/* dev/132: a row the runtime could not fetch — the portal's own steps, and the\n   shared catalog import right where they end. */\n.download {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 0.74rem;\n  color: var(--curio-text-secondary);\n}\n\n.downloadHead {\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.steps {\n  margin: 0;\n  padding-left: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  word-break: break-word;\n}\n\n.importControl {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 2px;\n}\n\n.importInput {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  overflow: hidden;\n}\n\n.importButton {\n  font-size: 0.76rem;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 4px 12px;\n  cursor: pointer;\n  border: 1px solid var(--curio-border-strong);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n}\n\n.importControl:hover .importButton {\n  border-color: var(--curio-text-secondary);\n}\n\n.importButton[aria-disabled=\"true\"] {\n  cursor: default;\n  opacity: 0.55;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `TEh6pZWjeyiRjNQFDaws`,
	"header": `lxNwowoVtOHtCWNB57Uf`,
	"accentDot": `bIMdKUKUdIgsrGv6MW4c`,
	"kind": `JHdQP7XhXjhsxQSQVZ9A`,
	"lane": `I5G_2bsHmbxxPbktqcUW`,
	"laneLabel": `BnBwgTvs6qG_5Fo0MP7R`,
	"rows": `INdRHs2pXwg4U6ocjwmD`,
	"row": `ouyAiTrRz_qoVZ3hP50Z`,
	"rowLabel": `F_1x3r5g_Pbj9oC3E1y4`,
	"rowBody": `eKzeRSzyK6tPw49Keckv`,
	"rowActions": `ysb96DlvB8ubQ6Tq4FIf`,
	"rowLink": `VwqWuovNunvrQWufNd68`,
	"rowHead": `yaH5mRuvkrFazwrON_TP`,
	"name": `bcOJ3zxEg3AHxkHnkqnM`,
	"badge": `gixVx6KRSxX7ldsU5vo9`,
	"installedChip": `g4ho9r61LgieTEH17IIg`,
	"notInstalledChip": `KxeZnVqKLe3gIlqhsG2h`,
	"meta": `SdJCuvfFrfxadinoSFhg`,
	"url": `A2bgDzSziMVzeNNw1QAi`,
	"fit": `WcIrRiTOrKOCSgO4pXmk`,
	"requirement": `xKYoS8Yly6AVy0GolMoq`,
	"confirmRow": `tHzFFqSiJHfYIm7d9vEN`,
	"confirm": `VeXnuFg7DATkZhhWTKHA`,
	"recorded": `vgG7AYfJ6XiIuFAYhtm5`,
	"recordError": `EIhd1qWkWiqsI2zSbyUv`,
	"download": `cb6vmf_xMXQXg11Zwofr`,
	"downloadHead": `Xiu89pA5PpRnNYAhvBHG`,
	"steps": `BiNUBYJCBTiBHsYvNxxA`,
	"importControl": `TCmhD3ocs9b5Fw4Zx9IM`,
	"importInput": `_1MuoJb22vH3gzmSk9oI`,
	"importButton": `SySO8r786VFHCXbbqEMq`
};
export default ___CSS_LOADER_EXPORT___;
